import { put, SagaGenerator, select, takeLatest } from "typed-redux-saga";
import { Action, AnyAction } from "typescript-fsa";

import { ActivityActions, ActivitySelectors } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { FormEngineActions } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { Events } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";
import { WorkflowsActions } from "@com.mgmtp.a12.workflows/workflows-core/lib/actions";

import { isTaskDetailActivityId, isAntragDetailActivityId } from "../../utilities/activityUtils";

import { CHANGELOG_ACTIVITY, CHANGELOG_DOCUMENT_MODEL } from "./constants";

export function* openChangelogSaga(): SagaGenerator<void> {
	yield* takeLatest((action: AnyAction) => {
		return (
			FormEngineActions.event.match(action) &&
			Events.eventButtonTriggered.match(action.payload.engineEvent) &&
			action.payload.engineEvent.payload.name === "showChangelog"
		);
	}, openChangelog);
}

function* openChangelog(action: Action<FormEngineActions.FormEngineEventActions>): SagaGenerator<void> {
	const changelogActivity = yield* select(ActivitySelectors.activityById(CHANGELOG_ACTIVITY));
	if (changelogActivity) {
		yield* put(ActivityActions.cancel({ activityId: changelogActivity.id }));
		return;
	}

	const activity = yield* select(ActivitySelectors.activityById(action.payload.activityId));
	if (!activity?.descriptor.instance) {
		return;
	}

	yield* put(
		ActivityActions.create({
			activityDescriptor: {
				model: CHANGELOG_DOCUMENT_MODEL,
				mainDocumentReference: activity.descriptor.instance
			},
			initiatingActivityId: action.payload.activityId,
			activityId: CHANGELOG_ACTIVITY
		})
	);
}

export function* reloadChangelogSaga(): SagaGenerator<void> {
	yield* takeLatest(
		(action: AnyAction) => {
			if (!ActivityActions.save.done.match(action)) {
				return false;
			}
			const savedActivityId = action.payload.params.activityId;
			return isTaskDetailActivityId(savedActivityId) || isAntragDetailActivityId(savedActivityId);
		},
		function* () {
			const changelogActivity = yield* select(ActivitySelectors.activityById(CHANGELOG_ACTIVITY));
			if (!changelogActivity) {
				return;
			}
			yield* put(ActivityActions.reloadData({ activityId: CHANGELOG_ACTIVITY }));
		}
	);
}

export function* closeChangelogSaga(): SagaGenerator<void> {
	yield* takeLatest(WorkflowsActions.completeTask.done, function* () {
		const changelogActivity = yield* select(ActivitySelectors.activityById(CHANGELOG_ACTIVITY));
		if (changelogActivity) {
			yield* put(ActivityActions.cancel({ activityId: CHANGELOG_ACTIVITY }));
		}
	});
}

export function* closeChangelogOnStammdatenNavigateSaga(): SagaGenerator<void> {
	yield* takeLatest(
		(action: AnyAction) => {
			if (!ActivityActions.cancel.match(action)) {
				return false;
			}
			return true;
		},
		function* (action: Action<{ activityId: string }>) {
			const changelogActivity = yield* select(ActivitySelectors.activityById(CHANGELOG_ACTIVITY));
			if (!changelogActivity) {
				return;
			}
			// Close changelog if the cancelled activity was its initiator
			if (changelogActivity.initiatingActivityId === action.payload.activityId) {
				yield* put(ActivityActions.cancel({ activityId: CHANGELOG_ACTIVITY }));
			}
		}
	);
}
